const SportsMap = {
/*  Baseball: {
    apiname: "MBA",
    picture: "/img/1661950.jpg",
  },*/
  Football: {
    apiname: "MFB",
    picture: "/img/2570139.jpg",
  },
  "Womens Volleyball": {
    apiname: "WVB",
    picture: "/img/1277213.jpg",
  },
   "Mens Volleyball": {
    apiname: "MVB",
    picture: "/img/1263426.jpg",
  },
  "Womens Basketball": {
    apiname: "WBB",
    picture: "/img/159607.jpg",
  },
  "Mens Basketball": {
    apiname: "MBB",
    picture: "/img/1752757.jpg",
  },
  "Womens Softball": {
    apiname: "WSB",
    picture: "/img/iStock-511067832.jpg",
  },
/*  "Womens Lacrosse": {
    apiname: "WLA",
    picture: "/img/iStock-2148139598.jpg"
  },
  */
  /*
  "Mens Lacrosse": {
    apiname: "MLA",
    picture: "/img/iStock-487459428.jpg"
  },
  */
  "Mens Soccer": {
    apiname: "MSO",
    picture: "/img/iStock-1904589046.jpg"
  },
  "Womens Soccer": {
    apiname: "WSO",
    picture: "/img/iStock-1432305427.jpg",
  },
  "Mens Baseball": {
    apiname: "MBA",
    picture: "/img/1661950.jpg"
  },
  //"Test Sport": { apiname: "TST" },
};

const SportsMapInv = {
//  MBA: "Baseball",
  MFB: "Football",
  WVB: "Womens Volleyball",
  MVB: "Mens Volleyball",
  WBB: "Womens Basketball",
  WSB: "Womens Softball",
  MBB: "Mens Basketball",
//  MLA: "Mens Lacrosse",
//  WLA: "Womens Lacrosse",
  MSO: "Mens Soccer",
  WSO: "Womens Soccer",
  MBA: "Mens Baseball",
//  TST: "Test Sport",
};

const YearMap = {
  "Fr.": "Freshman",
  "So.": "Sophomore",
  "Jr.": "Junior",
  "Sr.": "Senior",
};

const YearMapInv = {
  Freshman: "Fr.",
  Sophomore: "So.",
  Junior: "Jr.",
  Senior: "Sr.",
};

export { SportsMap, SportsMapInv, YearMap, YearMapInv };
